import React from "react";
import BeneficialOwnershipTab from "components/PLCTABS/BeneficialOwnershipTab";

function BeneficialOwners({ handleNextBtn, handleBackBtn, partialData }) {
  return (
    <div>
      <BeneficialOwnershipTab
        handleNextBtn={handleNextBtn}
        handleBackBtn={handleBackBtn}
        partialData={partialData}
        submitBtnLabel={"Next Step"}
      />
    </div>
  );
}

export default BeneficialOwners;
